import { Observable, throwError } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { applyErrorHandler } from './apply-error-handler';
import { InvalidStateError } from './invalid-state-error';
import { PlannedError } from './planned-error';

export const throwAndHandleError = (
  errorHandler: unknown,
  error: PlannedError | InvalidStateError = new InvalidStateError('An instantly handled error appeared.')
): Observable<never> => applyErrorHandler(errorHandler).pipe(switchMap(() => throwError(() => error)));
